import { Routes } from '@angular/router';
import { CartComponent } from './components/cart/cart.component';
import { ReservationComponent } from './components/reservation/reservation.component';

export const CartRouting: Routes = [
  {
    path: '',
    component: CartComponent
  },
  {
    path: 'order/:id',
    component: ReservationComponent
  }
];
